import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getLocalities} from '../../services/getLocalities';
import {UseGetLocalitiesQueryProps} from './types';

export function useGetLocalitiesQuery({enabled, ...params}: UseGetLocalitiesQueryProps) {
	return useQuery({
		queryKey: [QUERY_KEYS.LOCALITIES, params],
		queryFn: ({signal}) => getLocalities({signal, ...params}),
		enabled,
	});
}
